var link_viewer_default = {
  "fontElementMap": "_196RZ",
  "link": "_6EXcE",
  "linkInEditor": "_3k1Ma",
  "linkInViewer": "oX5VD",
  "toolbarUrlContainer": "Yxf0Y",
  "toolbarUrl": "O5yVi",
  "toolbarUrlAnchor": "lSyi8"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
